/* eslint-disable */
import { useParameter, useExport } from "../../../shared";
import * as React from "react";
import { REPORT_ID } from "../constants";

export function useExportQuery(title, subtitle) {
  const exportBuilder = useExport();
  const [calendar] = useParameter<number[]>("@calendar");
  const [calendarDisplay] = useParameter<number[]>("@calendar_display");
  const [baseIndex] = useParameter<number>("@base_index");
  const [baseIndexDisplay] = useParameter<number>("@base_index_display");
  const [commodities] = useParameter<number[]>("@commodities");
  const [commoditiesDisplay] = useParameter<number[]>("@commodities_display");
  const [method] = useParameter<number>("@method");

  React.useEffect(() => {
    exportBuilder.set('title', title);
    exportBuilder.set('subtitle', subtitle);
    exportBuilder.set('reportDefinition', {
      reportId: exportBuilder.reportId,
      name: { 9: title },
      parameters: {
        "@calendar": calendar,
        "@calendar_display": calendarDisplay && calendarDisplay.map(String),
        "@base_index": baseIndex,
        "@baseIndex": baseIndex && [baseIndex],
        "@base_index_display": baseIndexDisplay,
        "@commodities": commodities,
        "@commoditiesDisplay": commoditiesDisplay,
        "@method": method,
        "@methods": [1, 2],
      }
    }); 
  }, [title, subtitle, exportBuilder, calendar, commodities, calendarDisplay, baseIndex, baseIndexDisplay, method]);
}

